import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-range-selector',
  templateUrl: './range-selector.component.html',
  styleUrls: ['./range-selector.component.scss']
})
export class RangeSelectorComponent implements AfterViewInit {

  maxLimit: number;
  minLimit: number;
  @Input() min: number;
  @Input() max: number;
  @Input() icon: string;
  @Input() label: string;

  @ViewChild('minThumb', { static: true }) minThumb: ElementRef;
  @ViewChild('maxThumb', { static: true }) maxThumb: ElementRef;

  @ViewChild('minInput', { static: true }) minInput: ElementRef;
  @ViewChild('maxInput', { static: true }) maxInput: ElementRef;

  ngAfterViewInit() {
    this.maxLimit = this.max;
    this.minLimit = this.min;
  }

  drag(mouseEvent, oppositeThumb) {

    const _this = this; // it used to access global vars inside inner fcunctions
    let thumb = mouseEvent.srcElement;
    let mousePos = mouseEvent.clientX;

    thumb.onmousedown = dragStart;

    function dragStart(dragStartEvent) {
      dragStartEvent.preventDefault();
      document.onmouseup = dragStop;
      document.onmousemove = dragMove;
    }

    function dragMove(dragMoveEvent) {
      let thumbClass = thumb.className;
      let thumbWidth = thumb.offsetWidth;
      let sliderWidth = thumb.parentElement.offsetWidth;
      let moveDirection = mousePos - dragMoveEvent.clientX;
      mousePos = dragMoveEvent.clientX;

      let leftPos = thumb.offsetLeft - moveDirection;
      let rightPos = thumb.offsetLeft + thumb.offsetWidth;
      let rightLimit = sliderWidth - thumb.offsetWidth;

      //set left limit
      if (leftPos < 0) {
        leftPos = 0;
      }

      // set right limit
      if (rightPos <= sliderWidth && leftPos > rightLimit) {
        leftPos = rightLimit;
      }

      switch (thumbClass) {
        case 'min':
          thumb.style.zIndex = '9';
          oppositeThumb.style.zIndex = '0';
          if ((leftPos + thumbWidth) <= oppositeThumb.offsetLeft) {
            thumb.style.left = leftPos + "px";
          }
          break;
        case 'max':
          thumb.style.zIndex = '9';
          oppositeThumb.style.zIndex = '0';
          if ((leftPos - thumbWidth) >= (oppositeThumb.offsetLeft)) {
            thumb.style.left = leftPos + "px";
          }
          break;
      }

      // calculate left distance percentage and update input
      let percent: any = leftPos / rightLimit;
      let newVal = Math.round(_this.maxLimit * percent.toFixed(2));

      if (thumbClass === 'min') {
        _this.min = newVal;
      } else if (thumbClass === 'max') {
        _this.max = newVal;
      }

    }

    function dragStop() {
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }

  updateSlider(event) {
    let val = parseInt(event.srcElement.value);
    let className = event.srcElement.className;

    if (val < 0 || isNaN(val)) {
      val = 0
    }

    let maxThumb = this.maxThumb.nativeElement;
    let minThumb = this.minThumb.nativeElement;

    let maxThumbPos = maxThumb.offsetLeft;
    let minThumbPos = minThumb.offsetLeft;

    let sliderWidth = maxThumb.parentElement.offsetWidth;
    let thumbWidth = maxThumb.offsetWidth;

    let minRightLimit = maxThumbPos;

    let maxLeftLimit = minThumbPos + thumbWidth;

    let maxRightLimit = sliderWidth - maxThumb.offsetWidth;

    let percent = val / this.maxLimit;

    let newPos = percent * sliderWidth;

    switch (className) {

      case 'min':
        this.min = val;
        if (val > this.maxLimit || newPos > minRightLimit) {
          minThumb.style.left = (minRightLimit - thumbWidth) + 'px';
        } else if (val < this.minLimit) {
          minThumb.style.left = '0';
          this.min = this.minLimit;
        } else {
          minThumb.style.left = percent * 100 + '%';
        }
        break;

      case 'max':
        this.max = val;
        if (val > this.maxLimit || newPos > maxRightLimit) {
          maxThumb.style.left = (maxRightLimit) + 'px';
        } else if (newPos > maxLeftLimit) {
          maxThumb.style.left = percent * 100 + '%';
        } else {
          maxThumbPos = minThumbPos + thumbWidth;
          maxThumb.style.left = maxThumbPos + 'px';
        }
        break;
    }

  }

  updateInputOnBlur(className, minInput, maxInput) {
    let minVal = parseInt(minInput.value);
    let maxVal = parseInt(maxInput.value);

    switch (className) {
      case 'min':
        if (minVal > maxVal || minVal < this.minLimit) {
          this.min = this.minLimit;
          this.minInput.nativeElement.value = this.minLimit;
          this.minThumb.nativeElement.style.left = 0
        }
        break;
      case 'max':
        if (maxVal < minVal) {
          this.max = this.maxLimit;
          this.maxInput.nativeElement.value = this.maxLimit;
          this.maxThumb.nativeElement.style.left = 'calc(100% - 20px)';
        }
        break;
    }
  }

}
